import type { Question } from '@verzekeringapp-mono/shared/src/models/value_meter_question'

const hasRule = (rules: string, ruleName: string) => rules
  .split('|')
  .map(r => r.trim())
  .filter(Boolean)
  .some(r => r === ruleName || r.startsWith(`${ruleName}:`))

export const getNormalizedRulesForQuestion = (question: Question): string => {
  const original = question.rules ?? ''
  const trimmed = String(original).trim()

  if (question.type === 'number' && !hasRule(trimmed, 'numeric')) {
    return `numeric|${trimmed}`
  }

  return trimmed
}
